@if (Scrollable) {
  <ng-container>
    <div
      id="graphFixed"
      [class.pie]="IsPie"
      class="diagram-date"
      #chartFixed
    ></div>
    <ng-scrollbar track="horizontal" style="height: 320px" #scrollable>
      <div
        id="graph"
        [class.pie]="IsPie"
        class="diagram-date"
        (window:resize)="onResize()"
        #chart
      >
        <div id="dummy">
          <!-- this allows us to find the correct width for the chart -->
        </div>
      </div>
    </ng-scrollbar>
  </ng-container>
}

@if (!Scrollable) {
  <ng-container>
    <div
      id="graph"
      [class.pie]="IsPie"
      class="diagram-date"
      (window:resize)="onResize()"
      #chart
    >
      <div id="dummy">
        <!-- this allows us to find the correct width for the chart -->
      </div>
    </div>
  </ng-container>
}

@if (hasResetButton && (isBrush || customRange || displayResetBtn)) {
  <button class="reset-btn" (click)="onReset()">
    <i nz-icon nzType="icons:refresh" class="svg-icon fillwhite"></i>
    Reset View
  </button>
}
